import { Header } from "../../components/header/Header"
import { Heading } from "../../components/heading/Heading"
import { P } from "../../components/p/P"
import { ManagementTeamWrapper } from "./styles"

export const ManagementTeam = () => {
    return (
        <ManagementTeamWrapper>
            <Header>Management Team</Header><br />
            <Heading level={2}>Mr. Anshul Goel</Heading>
            <Heading level={3} style={{color: '#3b82f6'}}>Director</Heading>
            <P>Mr. Anshul Goel holds a Management degree in Entrepreneurship and Marketing and is the young spirit of ND Group who is working towards fulfilling the modern dreams of India. He develops the group by his young and innovative bent of mind, with which he has been working to make the group achieve its goal to provide India with residential and commercial spaces with an aim that they set benchmark standards in the industry. His proactive and dynamic approach along with his entrepreneurial skills has catalyzed the pace at which ND Group is approaching to aim set new benchmarks in real estate development space.</P>
        </ManagementTeamWrapper>
    )
}